// Import Services
import Services from '../core/services'

export default {

  getSiteData( siteIdList ) {
    const chunks = this.getChunks(siteIdList, 2100);
    const promiseList = [];
    chunks.forEach((siteIdListChunk) => {
      promiseList.push(
        new Promise((resolve) => {
          return Services
            .post("api/siterentals/sitedata", {
              siteIdListChunk         
            })
            .then( ({data}) => {
              if (data && data.success) {
                return resolve({
                  sitedata: data.sitedata || [],
                });
              }
    
              return resolve({});
            })
            .catch(() => {
              return resolve({});
            });
        })
      );
    });
    return Promise.all(promiseList).then((responses) => {
      const data = {sitedata: []};
      let currSiteId;
      let currSite;
      responses.forEach((response) => {
        response.sitedata.forEach((site) => {
          site.dates.forEach((date) => {
            if(date.siteId !== currSiteId){
              if(currSiteId) data.sitedata.push(currSite);
              currSiteId = date.siteId;
              currSite = {siteId: currSiteId, dates: []};
            }
            currSite.dates.push(date);
          });
        });
      });
      data.sitedata.push(currSite);
      return data;
    });
  },

  processRentals( formData ) {
    return new Promise((resolve) => {
      return Services
        .post(`api/siterentals/processrentals`, formData )
        .then( ({data}) => {
          if (data && data.success) {
            return resolve({
              success: true
            });  
          }

          return resolve({
            success: false,
            error: data.error,
          });
        })
        .catch(() => {
          return resolve({
            success: false
          });
        });
    });
  },

  checkAvailableDays(siteId,beginDate,endDate){
    
    return Services
      .post(`api/siterentals/checkavailabledays`, {siteId,beginDate,endDate})
      .then( ({data}) => {
        if (data && data.available) {
          return true;
        }
        return false;
      })
      .catch(() => {
        return false;
      });
    
  },
  
  getChunks(siteIdList, maxChunkSize){
    const chunksList = [];
    let currChunkSize = 0;
    let currChunk = "";
    siteIdList.forEach((site) => {
      if(currChunk.length) currChunk += "," + site.siteId + "|";
      else currChunk += site.siteId + "|";
      site.dateList.forEach((date) => {
        if(currChunk.length) {
          if(currChunk.charAt(currChunk.length - 1) !== "|") currChunk += "&";
          currChunk += date;
        }
        else currChunk += site.siteId + "|" + date;
        currChunkSize += 1;
        if(currChunkSize === maxChunkSize){
          chunksList.push(currChunk);
          currChunkSize = 0;
          currChunk = "";
        }
      });
    });
    if(currChunk.length) chunksList.push(currChunk);
    return chunksList;
  }

}